import { IconArrowUpRight, IconUserCircle, IconUserFilled, IconUserShare } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import DateRange from '../../components/DateRange/DateRange';
import Layout from '../../layout/Layout';
import { dateIntoYYYY_MM_DD } from '../../utils/dateTimeConverter';
import LinkClickChart from './Components/LinkClickChart';
import TopFiveTable from './Components/TopFiveTable';
import UserRegistrationChart from './Components/UserRegistrationChart';

const Dashboard = () => {
    const [topUsers, setTopUsers] = useState([]);
    const [userCount, setUserCount] = useState({});
    const [countData, setCountData] = useState({});
    const [loading, setLoading] = useState(true);
    const [date, setDate] = useState({ startDate: '', endDate: '' });

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setDate(newDate)
    }

    const fetchTopUsers = async () => {
        let postData = {
            startDate: dateIntoYYYY_MM_DD(date.startDate),
            endDate: dateIntoYYYY_MM_DD(date.endDate)
        }
        const resp = await postApi((postData?.startDate ? postData : {}), `${urlApi.top5Users}10`);
        if (resp.responseCode === 200) {
            setTopUsers(resp.data);
        } else {
            setTopUsers([]);
        }
    }

    const fetchUserCount = async () => {
        const resp = await getApi(`${urlApi.userCount}`);
        if (resp.responseCode === 200) {
            setUserCount(resp.data);
        } else {
            setUserCount({});
        }
    }

    const fetchCountData = async () => {
        setLoading(true);
        const resp = await getApi(`${urlApi.countData}`);
        setLoading(false);
        if (resp.responseCode === 200) {
            setCountData(resp.data);
        } else {
            setCountData({});
        }
    }

    useEffect(() => {
        fetchUserCount();
        fetchCountData();
    }, []);

    useEffect(() => {
        fetchTopUsers();
        return () => { };
    }, [date]);

    return (
        <Layout>
            <div className="grid grid-cols-3 mb-3 !gap-3">
                <div className="col-span-1">
                    <div className="p-3 w-full rounded-lg bg-blue-100 text-center flex items-center justify-center !gap-4 mb-2 shadow-md">
                        <IconUserShare size={64} className='text-blue-400' />
                        <div className='text-center'>
                            <p className='text-sm font-semibold text-gray-700'>Today Registered User</p>
                            <div className='flex items-center justify-center gap-3'>
                                <div>
                                    <p className='text-[42px] font-extrabold text-blue-700 leading-none'>{userCount?.todayRegisteredUserCountApp || 0}</p>
                                    <h5 className='text-blue-800 text-xs font-semibold'>App</h5>
                                </div>
                                <div className='bg-gray-700 w-1 h-full'>|</div>
                                <div>
                                    <p className='text-[42px] font-extrabold text-blue-700 leading-none'>{userCount?.todayRegisteredUserCountChat || 0}</p>
                                    <h5 className='text-blue-800 text-xs font-semibold'>Chat</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-3 w-full rounded-lg bg-green-100 text-center flex items-center justify-center !gap-4 mb-2 shadow-md relative">
                        <Link to={{ pathname: '/users' }} state={'TODAY_ACTIVE'} className="absolute h-6 w-6 !p-1 rounded-full flex items-center justify-center bg-green-500 right-2 top-2"><IconArrowUpRight className='text-green-200' /></Link>
                        <IconUserFilled size={64} className='text-green-400' />
                        <div className='text-center'>
                            <p className='text-sm font-semibold text-gray-700'>Today Active User</p>
                            <div className='flex items-center justify-center gap-3'>
                                <div>
                                    <p className='text-[42px] font-extrabold text-green-700 leading-none'>{userCount?.todayUserCountApp || 0}</p>
                                    <h5 className='text-green-800 text-xs font-semibold'>App</h5>
                                </div>
                                <div className='bg-gray-700 w-1 h-full'>|</div>
                                <div>
                                    <p className='text-[42px] font-extrabold text-green-700 leading-none'>{userCount?.todayUserCountChat || 0}</p>
                                    <h5 className='text-green-800 text-xs font-semibold'>Chat</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-3 w-full rounded-lg bg-purple-100 text-center flex items-center justify-center !gap-4 shadow-md">
                        <IconUserCircle size={64} className='text-purple-400' />
                        <div className='text-center'>
                            <p className='text-sm font-semibold text-gray-700'>Total Registered User</p>
                            <div className='flex items-center justify-center gap-3'>
                                <div>
                                    <p className='text-[42px] font-extrabold text-purple-700 leading-none'>{userCount?.totalUserCountApp || 0}</p>
                                    <h5 className='text-purple-800 text-xs font-semibold'>App</h5>
                                </div>
                                <div className='bg-gray-700 w-1 h-full'>|</div>
                                <div>
                                    <p className='text-[42px] font-extrabold text-purple-700 leading-none'>{userCount?.totalUserCountChat || 0}</p>
                                    <h5 className='text-purple-800 text-xs font-semibold'>Chat</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-2">
                    <UserRegistrationChart />
                </div>
            </div>

            <div className="grid items-center grid-cols-5 !gap-3 mb-3">

                <StatsCard title={"TOTAL LINKS"} loadingState={loading} icon={"/images/link.svg"} value={countData?.totalData?.linkCount || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />
                <StatsCard title={"TODAY LINKS"} loadingState={loading} icon={"/images/link.svg"} value={countData?.todayData?.linkCount || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />

                <StatsCard title={"LINK CLICKED"} loadingState={loading} icon={"/images/link.svg"} value={countData?.totalData?.linkClick || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />
                <StatsCard title={"TODAY CLICKED"} loadingState={loading} icon={"/images/link.svg"} value={countData?.todayData?.linkClick || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />

                <StatsCard title={"TOTAL CLICKS"} loadingState={loading} icon={"/images/users.svg"} value={countData?.totalData?.totalClick || '0'} colorCode={'text-[#144EE3]'} accentColor={'bg-[#144EE310]'} />

                <StatsCard title={"TOTAL QR CODES"} loadingState={loading} icon={"/images/qr-yellow.svg"} value={countData?.totalData?.qrCount || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />
                <StatsCard title={"TODAY QR CODES"} loadingState={loading} icon={"/images/qr-yellow.svg"} value={countData?.todayData?.qrCount || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />

                <StatsCard title={"QR CODE SCANS"} loadingState={loading} icon={"/images/qr-yellow.svg"} value={countData?.totalData?.qrClick || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />
                <StatsCard title={"TODAY QR CODE SCANS"} loadingState={loading} icon={"/images/qr-yellow.svg"} value={countData?.todayData?.qrClick || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />

                <StatsCard title={"TODAY CLICKS"} loadingState={loading} icon={"/images/users.svg"} value={countData?.todayData?.totalClick || '0'} colorCode={'text-[#144EE3]'} accentColor={'bg-[#144EE310]'} />

                <StatsCard title={"TOTAL PAGES"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.totalData?.pageCount || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />
                <StatsCard title={"TODAY PAGES"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.todayData?.pageCount || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />

                <StatsCard title={"PAGES CLICKED"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.totalData?.pageClick || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />
                <StatsCard title={"TODAY PAGES CLICKED"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.todayData?.pageClick || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />

                <div></div>

                <StatsCard title={"TOTAL BUSINESS CARDS"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.totalData?.businessCardCount || '0'} colorCode={'text-[#7013a2]'} accentColor={'bg-[#7013a21a]'} />
                <StatsCard title={"TODAY CARDS"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.todayData?.businessCardCount || '0'} colorCode={'text-[#7013a2]'} accentColor={'bg-[#7013a21a]'} />

                <StatsCard title={"CARDS CLICKED"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.totalData?.businessCardClick || '0'} colorCode={'text-[#7013a2]'} accentColor={'bg-[#7013a21a]'} />
                <StatsCard title={"TODAY CARDS CLICKED"} loadingState={loading} icon={"/images/page-click.svg"} value={countData?.todayData?.businessCardClick || '0'} colorCode={'text-[#7013a2]'} accentColor={'bg-[#7013a21a]'} />
            </div>

            <div className="mb-3">
                <LinkClickChart />
            </div>

            <div className='shadow-md !px-3 py-2 rounded-lg'>
                <div className='flex items-center justify-between'>
                    <p className='text-lg font-medium mb-1'>Top Users</p>
                    <DateRange onApplyClick={(date) => onDateChange(date)} date={date} />
                </div>
                <div className="grid grid-cols-5 !gap-3 mb-3 ">
                    {topUsers?.length > 0 ?
                        topUsers.map((user, index) => (
                            <Link key={index} to={"/user/" + user?._id} target='_blank' >
                                <div className="text-center p-3 bg-white rounded-md shadow-md">
                                    <img className="w-16 h-16 aspect-square bg-gray-300 mx-auto mb-2 rounded-full" src={user?.userProfilePic} alt='' />
                                    <div>
                                        <p className="font-medium">{user.userName}</p>
                                        <p className="text-sm text-gray-700 font-normal">{user.uniqueLinkClicks || 0} Clicks</p>
                                    </div>
                                </div>
                            </Link >
                        )) : <div className='col-span-5 text-center py-16 flex justify-center items-center w-full'> <p className='text-center text-sm text-red-600 font-medium'>No User Found!</p></div>
                    }
                </div>
            </div>
            <TopFiveTable />
        </Layout>
    )
}

export default Dashboard;

export const StatsCard = ({ title, icon, value, colorCode, accentColor, loadingState }) => {
    return (
        <div className={`${accentColor} py-3 px-5 rounded-lg text-center`}>
            <img src={process.env.PUBLIC_URL + icon} alt="" />
            {loadingState ? <div className={`animate-pulse ${accentColor} rounded-lg w-[100%] h-[38px]`}></div> : <p className={`mb-0 text-[25px] font-bold text-[var(--black)]`}>{value}</p>}
            <p className={`mb-0 text-[12px] font-semibold ${colorCode}`}>{title}</p>

        </div>
    )
}